import { RootState } from 'store'

const selectAppData = (state: RootState) => state.app
const selectToken = (state: RootState) => selectAppData(state).token
const selectUserId = (state: RootState) => selectAppData(state).userId
const selectSellerId = (state: RootState) => selectAppData(state).sellerId
const selectSellerStatus = (state: RootState) => selectAppData(state).sellerStatus
const selectRole = (state: RootState) => selectAppData(state).role
const selectEmployeeId = (state: RootState) => selectAppData(state).employeeId
const selectEmployee = (state: RootState) => selectAppData(state).employee
const selectIsStoreHidden = (state: RootState) => selectAppData(state).isStoreHidden
const selectIsHiddenBySeller = (state: RootState) => selectAppData(state).isHiddenBySeller
const selectIsAuth = (state: RootState) => Boolean(selectToken(state))

export const selectors = {
  selectToken,
  selectUserId,
  selectSellerId,
  selectSellerStatus,
  selectRole,
  selectEmployeeId,
  selectEmployee,
  selectIsStoreHidden,
  selectIsHiddenBySeller,
  selectIsAuth
}
